import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
function EllipsisHSolidGlyph(props, svgRef) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: _jsx("path", { d: "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z" }, void 0) }), void 0));
}
const ForwardRef = React.forwardRef(EllipsisHSolidGlyph);
export default ForwardRef;
